import React, { useEffect, useState } from 'react'
import * as S from './styles'

import DetailsMenu from './DetailsMenu'
import DetailsItem from './DetailsItem'

import { useRouter } from 'next/router'

const ContentDetailsSection = ({ data }) => {
  const router = useRouter()

  const [currentIndex, setCurrentIndex] = useState()

  useEffect(() => {
    if (!router) return

    const defaultIndex = router.query.section
    if (defaultIndex) {
      setCurrentIndex(parseInt(defaultIndex))
    } else {
      setCurrentIndex(0)
    }
  }, [router])

  return (
    data && (
      <S.ContentDetailsSectionWrapper>
        <S.ContentDetailsSectionContainer id="details" className="mw-unsigned">
          <DetailsMenu
            data={data}
            indexState={currentIndex}
            indexHandler={setCurrentIndex}
          />

          <S.ContentDetailsItemsContainer>
            <DetailsItem data={data[currentIndex]} />
          </S.ContentDetailsItemsContainer>
        </S.ContentDetailsSectionContainer>
      </S.ContentDetailsSectionWrapper>
    )
  )
}

export default ContentDetailsSection
